import { render, staticRenderFns } from "./IconAddFillRounded.vue?vue&type=template&id=2dfba22b&scoped=true"
import script from "./IconAddFillRounded.vue?vue&type=script&lang=js"
export * from "./IconAddFillRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfba22b",
  null
  
)

export default component.exports